import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Award, Thermometer, UserCheck, Clock } from 'lucide-react';
import { BENEFITS } from '../data/content';

const iconMap = [Zap, Award, Thermometer, UserCheck, Clock];

const Benefits = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-primary-orange font-bold tracking-wider uppercase mb-3">Zašto Mi?</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-neutral-darkNavy">Prednosti Tip-Top Servisa</h3>
          <div className="w-24 h-1 bg-primary-blue mx-auto mt-6 rounded-full" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 justify-center">
          {BENEFITS.map((benefit, index) => {
            const Icon = iconMap[index];
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-start p-6 rounded-2xl hover:bg-gray-50 transition-colors duration-300"
              >
                <div className="flex-shrink-0 w-14 h-14 bg-primary-lightBlue/10 rounded-xl flex items-center justify-center mr-6 text-primary-blue">
                  <Icon size={28} />
                </div>
                <div>
                  <h4 className="text-xl font-bold text-neutral-darkNavy mb-2">{benefit.title}</h4>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
